import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider, createTheme } from '@mantine/core'
import '@mantine/core/styles.css'
import './index.css'
import App from './App.jsx'
import { initializeFirebase } from './firebase'

const theme = createTheme({
  primaryColor: 'violet',
  defaultRadius: 'md',
})

initializeFirebase().then(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <MantineProvider theme={theme} defaultColorScheme="dark">
        <App />
      </MantineProvider>
    </StrictMode>,
  )
});
